import React, { useEffect, useState } from "react";
import PromoBanner from "../Components/PromoBanner";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const PrivacyPolicy = () => {
  const [policyContent, setPolicyContent] = useState(""); // State to hold fetched content
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch Privacy Policy content from API
  const fetchPolicyContent = async () => {
    setIsLoading(true);

    try {
      const response = await fetch(
        "https://backend.printtrio.co.uk/api/pages/get-policy"
      );

      if (!response.ok) {
        throw new Error("Failed to fetch privacy policy.");
      }

      const data = await response.json();
      if (data.success && data.data && data.data.length > 0) {
        setPolicyContent(data.data[0].content); // Set the HTML content from API
      } else {
        setError("No privacy policy data found.");
      }
    } catch (err) {
      console.error("Error fetching privacy policy:", err);
      setError("An error occurred while fetching the privacy policy.");
    } finally {
      setIsLoading(false);
    }
  };

  // UseEffect to fetch data when the component mounts
  useEffect(() => {
    fetchPolicyContent();
  }, []);

  return (
    <div>
      <PromoBanner />
      <Navbar />
      {isLoading ? (
        <div className="flex justify-center items-center h-screen">
          {/* Tailwind simple spinner */}
          <svg
            className="animate-spin h-12 w-12 text-pink-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            />
          </svg>
        </div>
      ) : (
        <>
      <div className="px-8 py-12 font-sans text-gray-800 max-w-screen-2xl mx-auto relative">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        <p className="mb-4">Protecting your personal details on our website</p>
        <p className="text-sm text-gray-600 mb-6">Last updated: Dynamic Content</p>

        {error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <div
            className="space-y-6 text-sm text-gray-700"
            dangerouslySetInnerHTML={{ __html: policyContent }} // Render HTML content
          />
        )}
      </div>
      <Footer />
      </>
      )}
    </div>
  );
};

export default PrivacyPolicy;
